import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

// Layout Components
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";

// Pages
import HomePage from "@/pages/HomePage";
import SobrePage from "@/pages/SobrePage";
import TrabalhistaPage from "@/pages/TrabalhistaPage";
import TributarioPage from "@/pages/TributarioPage";
import ImobiliarioPage from "@/pages/ImobiliarioPage";
import PrevidenciarioPage from "@/pages/PrevidenciarioPage";
import CivelPage from "@/pages/CivelPage";
import FamiliaPage from "@/pages/FamiliaPage";
import PenalPage from "@/pages/PenalPage";
import ContatoPage from "@/pages/ContatoPage";
import JulgadosPage from "@/pages/JulgadosPage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white flex flex-col">
          <Toaster position="top-right" richColors />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/sobre" element={<SobrePage />} />
              <Route path="/direito-trabalhista" element={<TrabalhistaPage />} />
              <Route path="/direito-tributario" element={<TributarioPage />} />
              <Route path="/direito-imobiliario" element={<ImobiliarioPage />} />
              <Route path="/direito-previdenciario" element={<PrevidenciarioPage />} />
              <Route path="/direito-civel" element={<CivelPage />} />
              <Route path="/direito-familia" element={<FamiliaPage />} />
              <Route path="/direito-penal" element={<PenalPage />} />
              <Route path="/contato" element={<ContatoPage />} />
              <Route path="/julgados" element={<JulgadosPage />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
